<template>
  <div class="ui segment content-footer">
      <div class="ui grid middle aligned">
        <div class='four wide column'>
          <img class='ui image' v-bind:src="image" />
        </div>
        <div class='twelve wide column'>
          <div class='ui  middle aligned footer-message'>You have been sent this email as part of the "{{ programTitle }}" Booster Program.
Please contact your administrator with any questions.</div></div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'ContentFooter',
  props: [
    'image',
    'programTitle'
  ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content-footer {
    background-color: #FFF;
    padding: 15px;
    text-align: left;

    
}

.footer-message {
    color: #888;
    font-size: 12px;
    line-height: 16px;
}

@media (max-width: 640px) {
  .content-footer {
    border-radius: 0px;
  }
  .ui.segment {
    border-radius: 0px !important;
  }
}

</style>
